import { useEffect, useState } from "react";
import type { User } from "firebase/auth";
import { subscribeToUser } from "../lib/firebase";

/**
 * Firebase auth state: `undefined` while the session is being restored,
 * then the signed-in User or null. Pass enabled=false (non-firebase auth
 * modes) to skip the subscription entirely.
 */
export function useFirebaseUser(enabled: boolean): User | null | undefined {
  const [user, setUser] = useState<User | null | undefined>(enabled ? undefined : null);

  useEffect(() => {
    if (!enabled) return;
    return subscribeToUser(setUser);
  }, [enabled]);

  return enabled ? user : null;
}
